import {
  DownloadOutlined,
  FileExcelOutlined,
  MailOutlined,
  MessageOutlined,
  PrinterOutlined,
  DollarOutlined,
  CloseCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Collapse,
  Card
} from "antd";
import { PDFDownloadLink } from "@react-pdf/renderer";
import React, { useContext, useState, useEffect, useReducer, useRef, useMemo } from "react";
import { useAuthContext } from "../../common/providers/AuthProvider";
import { getPassengerData } from "../../helpers/PassegerData";
import ApiClient from "../../helpers/ApiClient";
import { setHotelPendingFlow } from "../../pages/Hotels/hotelTicketCache";

// import { downloadTicketPdf } from "../../helpers/TicketUtils";

import ActivitiesDoc from "../PdfDocuments/Activities/ActivitiesDoc";
import BuildPackageDoc from "../PdfDocuments/BuildPackage/BuildPackageDoc";

// import Invoice from "./Model/UserInvoice";
import FlightDoc from "../PdfDocuments/Flight/FlightDoc";
import BusDoc from "../PdfDocuments/Bus/BusDoc";
import HotelDoc from "../PdfDocuments/Hotel/HotelDoc";
import BusInvoiceDoc from "../PdfDocuments/Bus/BusInvoice";
import FlightInvoiceDoc from "../PdfDocuments/Flight/FlightInvoice";
import HotelInvoiceDoc from "../PdfDocuments/Hotel/HotelInvoice";
import ActivitiesInvoiceDoc from "../PdfDocuments/Activities/ActivitiesInvoice";
import BuildPackageInvoiceDoc from "../PdfDocuments/BuildPackage/BuildPackageInvoice";
// import PaymentGateway from "../../helpers/PaymentGateway";
// import { useSytContext } from "../../common/providers/SytProvider";
import ActivityTicketSidebar from "./ActivityTicketSidebar";
import { isFlightTicketSidebarHidden, getFlightDownloadSidebarHeader, shouldShowFlightSidebarActions } from "./AllTicketStatus";
import HotelTicketSidebar from "./Hotel/HotelTicketSidebar";
import "./Flight/FlightTicketScreen.scss";
import "./Hotel/HotelTicketScreen.scss";
import PayGateway from "../../helpers/PayGateway";
import PayMentSelection from "../PaymentSelection/PaymentSelection";
import { GlobalStatesContext } from "../providers";
import { useCurrencyContext } from "../providers/CurrencyProvider";
import PanVerification from "../../pages/Hotels/HotelCheckout/PanVerification";
import HotelCheckout from "../../pages/Hotels/HotelCheckout/HotelCheckout";
import {
  findAdultGuestMatchingPanName,
  getGuestDisplayName,
  isPanNameMatchedWithAnyAdultGuest,
  isPanRequiredForHotelVoucher,
  isMultiRoomPanRequiredForHotelVoucher,
  getHotelTicketPayableBase,
  computeHotelPgTransactionFee,
  isInternationalHotelBooking,
  resolveHotelBookingPanRequired,
} from "./Hotel/hotelhelper";

const ticketModalCloseIcon = (
  <CloseOutlined className="hotel-ticket-modal__close-icon" />
);

const { Panel } = Collapse;

const FlightDownloadPdfButton = React.memo(function FlightDownloadPdfButton({
  label,
}) {
  return <Button className="flight-ticket-download-btn">{label}</Button>;
});

const areFlightDownloadPanelPropsEqual = (prev, next) =>
  prev.ticketData === next.ticketData &&
  prev.fareRulesResp === next.fareRulesResp &&
  prev.cmsFareRules === next.cmsFareRules &&
  prev.logoImage === next.logoImage &&
  prev.invoiceData === next.invoiceData &&
  prev.showInvoice === next.showInvoice;

const FlightTicketDownloadPanel = React.memo(function FlightTicketDownloadPanel({
  ticketData,
  fareRulesResp,
  cmsFareRules,
  logoImage,
  invoiceData,
  showInvoice = false,
}) {
  const [activeKey, setActiveKey] = useState([]);
  const headerLabel = getFlightDownloadSidebarHeader(ticketData);

  const withFareDocument = useMemo(
    () => (
      <FlightDoc
        ticketData={ticketData}
        fareRulesResp={fareRulesResp}
        cmsFareRules={cmsFareRules}
        withFare={true}
        Logo={logoImage}
      />
    ),
    [ticketData, fareRulesResp, cmsFareRules, logoImage],
  );

  const withoutFareDocument = useMemo(
    () => (
      <FlightDoc
        ticketData={ticketData}
        fareRulesResp={fareRulesResp}
        cmsFareRules={cmsFareRules}
        withFare={false}
        Logo={logoImage}
      />
    ),
    [ticketData, fareRulesResp, cmsFareRules, logoImage],
  );

  const invoiceDocument = useMemo(
    () => (
      <FlightInvoiceDoc
        invoiceData={invoiceData}
        logo={logoImage}
        type={"invoice"}
      />
    ),
    [invoiceData, logoImage],
  );

  return (
    <div className="flight-ticket-sidebar-download">
      <Collapse
        activeKey={activeKey}
        onChange={(keys) =>
          setActiveKey(Array.isArray(keys) ? keys : keys ? [keys] : [])
        }
        animated={false}
        destroyInactivePanel={false}
        expandIcon={() => <DownloadOutlined style={{ color: "#3d96ee" }} />}
        expandIconPosition="right"
      >
        <Panel
          header={<span style={{ color: "#3d96ee" }}>{headerLabel}</span>}
          key="1"
        >
          <div className="trip-type-selector flight-ticket-download-options">
            <PDFDownloadLink document={withFareDocument} fileName="flightTicket.pdf">
              {() => <FlightDownloadPdfButton label="With Fare" />}
            </PDFDownloadLink>
            <PDFDownloadLink
              document={withoutFareDocument}
              fileName="flightTicket.pdf"
            >
              {() => <FlightDownloadPdfButton label="Without Fare" />}
            </PDFDownloadLink>
            {showInvoice ? (
              <PDFDownloadLink
                document={invoiceDocument}
                fileName="Flight_Invoice.pdf"
              >
                {({ loading }) =>
                  loading ? (
                    <Button className="flight-ticket-download-btn">
                      Loading document...
                    </Button>
                  ) : (
                    <Button className="flight-ticket-download-btn">
                      Invoice
                    </Button>
                  )
                }
              </PDFDownloadLink>
            ) : null}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
}, areFlightDownloadPanelPropsEqual);

const TicketSidebar = ({
  ticketData,
  setTicketData,
  type,
  onCancelTicket,
  getTicketDetails = () => { },
  cmsFareRules = {},
  fareRulesResp = null,
  logoImage,
  invoiceLogo = null,
  toggleVoucheredModal = () => { },
  VoucheredConfirm = () => { },
  VoucheredModalVisible,
  voucherData,
  showTicketPolicyBottom,
  setShowTicketPolicyBottom,
  IspartPayement,
  GetReleasePnr = () => { },
  ticketMode,
  samePanForAllRooms = false,
  validateHotelVoucherPanBeforePay = () => true,
}) => {
  const {
    isLogin: { agent },
    user,
  } = useAuthContext();
  const {
    state: {
      otherData: { ConvFee, promoData, redeemAmount, transactionFee },
      SeletedPayOption,
    },
    OnPaymentModeSelection: contextOnPaymentModeSelection,
    resetPayOption,
  } = useContext(GlobalStatesContext);
  const { activeCurrency, currencyValue } = useCurrencyContext();
  const [smsForm] = Form.useForm();
  const [pstMrkForm] = Form.useForm();
  const [removeMrkForm] = Form.useForm();
  const [emailForm] = Form.useForm();
  const [userInvoiceVisible, setUserinvoiceVisible] = useState(false);
  const [limitCount, setLimitCount] = useState({
    smsCount: 0,
    emailCount: 0,
  });
  const [pgData, setPgData] = useState({
    data: {},
    visible: false,
  });
  const [invoiceData, setInvoiceData] = useState({});
  const [withFare, setWithFare] = useState(-1);
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [smsModalVisible, setSmsModalVisible] = useState(false);
  const [pstMrkModalVisible, setPstMrkModalVisible] = useState(false);
  const [removeMrkModalVisible, setRemoveMrkModalVisible] = useState(false);
  const [flightEmailActiveKey, setFlightEmailActiveKey] = useState([]);
  const [IsPaymentGatway, setIsPaymentGatway] = useState(false);
  const PGDISPLAY = "PGDISPLAY";
  const PGDATA = "PGDATA";
  const PGTYPE = "PGTYPE";
  const initialState = { pgDisplay: false, pgData: {}, pgType: -1 };
  const [pgDetails, dispatchPgDetails] = useReducer(reducer, initialState);
  const [value, setValue] = useState();
  const [Deposit, setDeposit] = useState(false);
  const [isPanRequired, setIsPanRequired] = useState(false);
  function reducer(state, action) {
    switch (action.type) {
      case PGTYPE:
        return { ...state, pgType: action.payload };
      case PGDISPLAY:
        return { ...state, pgDisplay: action.payload };
      case PGDATA:
        return { ...state, pgData: action.payload };
      default:
        return state;
    }
  }

  const toggleEmailModal = () => {
    emailForm.resetFields();
    if (!emailModalVisible) loadpassengerData("Email");
    setEmailModalVisible((prev) => !prev);
  };

  const toggleSmsModal = () => {
    smsForm.resetFields();
    if (!smsModalVisible) loadpassengerData("SMS");
    setSmsModalVisible((prev) => !prev);
  };

  const togglePstMrkModal = () => {
    pstMrkForm.resetFields();
    setPstMrkModalVisible((prev) => !prev);
  };

  const toggleRemoveMrkModal = () => {
    removeMrkForm.resetFields();
    setRemoveMrkModalVisible((prev) => !prev);
  };

  // Function Add By Karthik 

  // Code End by karthik

  const loadpassengerData = (type) => {
    if (user && user?.UserID) {
      getPassengerData(user?.UserID).then((data) => {
        if (data.status) {
          if (type === "SMS") smsForm.setFieldsValue({ Mobile: data.Mobile });
          // else emailForm.setFieldsValue({ Email: data.Email });
        }
      });
    }
  };

  const addPostMarkup = (req) => {
    ApiClient.post("admin/postmarkup", req).then((res) => {
      if (res.status === 200) {
        if (res?.message) message.success(res?.message, 3);
        getTicketDetails();
        setPstMrkModalVisible(false);
      } else if (res.status === 400) {
        if (res?.message) message.success(res?.message, 3);
      } else {
        if (res?.message) message.success(res?.message, 3);
        else message.error("Failed");
      }
    });
  };

  const removePostMarkup = (req) => {
    ApiClient.post("admin/postmarkup", req).then((res) => {
      const failed = Number(res?.markupStatus ?? 200) >= 400;
      if (!failed && res.status === 200) {
        if (res?.message) message.success(res.message, 3);
        getTicketDetails();
        setRemoveMrkModalVisible(false);
      } else if (res?.message) {
        message.error(res.message, 3);
      } else {
        message.error("Failed");
      }
    }).catch((error) => {
      message.error(error?.message || "Failed");
    });
  };

  useEffect(() => {
    getInvoiceData();
  }, []);

  // === PAN Verification Modal ===
  const [panModalVisible, setPanModalVisible] = useState(false);
  const [panVerified, setPanVerified] = useState(false);
  const [verifiedPan, setVerifiedPan] = useState("");
  const [verifiedPanName, setVerifiedPanName] = useState("");
  const [verifiedPanMeta, setVerifiedPanMeta] = useState({});
  const [panModalError, setPanModalError] = useState("");
  const [panAddLoading, setPanAddLoading] = useState(false);

  const showPanModalMessage = (type, text) => {
    setPanModalError(text);
    message[type]({
      content: text,
      duration: 4,
      style: { zIndex: 10050 },
    });
  };

  // toggle modal open/close
  const togglePanModal = () => {
    setPanModalVisible((prev) => !prev);
    setPanVerified(false);
    setVerifiedPan("");
    setVerifiedPanName("");
    setVerifiedPanMeta({});
    setPanModalError("");
    setPanAddLoading(false);
  };

  // callback from PanVerification.jsx once Apply succeeds
  const handlePanVerificationResult = (panNumber, panName, panMeta = {}) => {
    setVerifiedPan(panNumber);
    setVerifiedPanName(String(panName ?? "").trim());
    setVerifiedPanMeta(panMeta ?? {});
    setPanVerified(true);
    setPanModalError("");
  };

  const handlePanVerifyError = (
    errorText = "Wrong Pan Number, Please check and put actual PAN Number.",
  ) => {
    setPanVerified(false);
    setVerifiedPan("");
    setVerifiedPanName("");
    setVerifiedPanMeta({});
    setPanModalError(errorText);
  };

  // handle Add PAN (after Apply success)
  const handleAddPan = () => {
    if (!panVerified || !verifiedPan) {
      setPanModalError("Please verify your PAN first.");
      return;
    }

    const matchedGuest = findAdultGuestMatchingPanName(
      verifiedPanName,
      ticketData?.guests,
      verifiedPan,
      verifiedPanMeta,
    );
    if (
      !isPanNameMatchedWithAnyAdultGuest(
        verifiedPanName,
        ticketData?.guests,
        verifiedPan,
        verifiedPanMeta,
      )
    ) {
      setPanModalError("Name not matched with pan no.");
      return;
    }

    setPanAddLoading(true);
    setPanModalError("");
    ApiClient.post("hotels-v2/verificationPan", {
      referenceNo: ticketData.RefNumber,
      pan_number: verifiedPan,
      guestFirstName: matchedGuest?.FirstName ?? matchedGuest?.firstName ?? "",
      guestLastName: matchedGuest?.LastName ?? matchedGuest?.lastName ?? "",
    })
      .then((res) => {
        setPanAddLoading(false);
        if (res.status === 200) {
          message.success({
            content: res.message || "PAN added successfully!",
            style: { zIndex: 10050 },
          });
          const panValue = String(verifiedPan).trim().toUpperCase();
          const updatedTicket = {
            ...ticketData,
            guests: (ticketData.guests ?? []).map((guest) => ({
              ...guest,
              Pan: panValue,
              pan: panValue,
            })),
          };
          setTicketData(updatedTicket);
          togglePanModal();
          getTicketDetails();
          confirmHotelBooking();
        } else {
          showPanModalMessage("error", res.message || "Failed to add PAN");
        }
      })
      .catch((err) => {
        setPanAddLoading(false);
        showPanModalMessage(
          "error",
          err.message || "Server error while adding PAN",
        );
      });
  };

  const getInvoiceData = () => {
    let formData = {};
    if (type === "Flight") {
      formData.serviceType = 1;
      formData.refNo = ticketData.referenceNumber;
    }

    if (type === "Hotel") {
      formData.serviceType = 2;
      formData.refNo = ticketData.RefNumber;
    }
    if (type === "Bus") {
      formData.serviceType = 3;
      formData.refNo = ticketData.bookingRefNo;
    }

    if (type === "Activities") {
      formData.serviceType = 4;
      formData.refNo = ticketData?.TourDetails?.[0].referenceNumber;
    }
    if (type === "BuildPackage") {
      formData.serviceType = 5;
      formData.refNo = ticketData.bookingRefNo;
    }
    if (formData) {
      ApiClient.post("admin/invoice", formData)
        .then((res) => {
          if (res.status == 200) {
            setInvoiceData(res.data);
          } else {
            setInvoiceData({});
          }
        })
        .catch((error) => {
          setInvoiceData({});
        });
    }
  };

  const submitPostMarkup = (val) => {
    if (user) {
      let formData = {
        amount: val.amount,
        userId: user?.UserID,
      };

      if (type === "Flight") {
        formData.serviceType = 1;
        formData.refNumber = ticketData.referenceNumber;
      }

      if (type === "Hotel") {
        formData.serviceType = 2;
        formData.refNumber = ticketData.RefNumber;
      }
      if (type === "Bus") {
        formData.serviceType = 3;
        formData.refNumber = ticketData.bookingRefNo;
      }

      if (type === "Activities") {
        formData.serviceType = 4;
        formData.refNumber = ticketData?.TourDetails?.[0].referenceNumber;
      }
      if (type === "BuildPackage") {
        formData.serviceType = 5;
        formData.refNumber = ticketData.RefNumber;
      }
      addPostMarkup(formData);
    }
  };

  const submitRemovePostMarkup = (val) => {
    if (!user || type !== "Hotel") {
      return;
    }
    removePostMarkup({
      amount: val.amount,
      userId: user?.UserID,
      serviceType: 2,
      refNumber: ticketData.RefNumber,
      action: "remove",
    });
  };
  const emailSendingRef = useRef(false);

  const sendEmailSmsETicket = (val) => {
    ApiClient.post("CommonUtility/notification", val).then((res) => {
      if (res.status === 200) {
        message.success(
          `${val.trigger === 2 ? "Sms" : "Email"} Sent Successfully`
        );
        setEmailModalVisible(false);
        setSmsModalVisible(false);
      } else {
        if (res?.message) message.error(res?.message, 3);
        else message.error("Failed");
      }
    }).finally(() => {
      emailSendingRef.current = false;
    });
  };

  const submitEmailForm = (val) => {
    if (emailSendingRef.current) {
      return;
    }
    if (limitCount.emailCount > 2) {
      message.error("Limit Exceeded");
      setEmailModalVisible(false);
      return;
    } else {
      setLimitCount((prev) => ({
        ...prev,
        emailCount: limitCount.emailCount + 1,
      }));
    }
    emailSendingRef.current = true;
    if (type === "Bus") {
      let formData = {
        phoneNumber: "string",
        travelType: 3,
        trigger: 1,
        bookingReference: ticketData.bookingRefNo,
        email: val.Email,
        withFare: withFare,
      };
      sendEmailSmsETicket(formData);
    }
    if (type === "Flight") {
      let formData = {
        phoneNumber: "string",
        travelType: 1,
        trigger: 1,
        bookingReference: ticketData.referenceNumber,
        email: val.Email,
        withFare: withFare,
      };

      sendEmailSmsETicket(formData);
    }
    if (type === "Hotel") {
      let formData = {
        phoneNumber: "string",
        travelType: 2,
        trigger: 1,
        bookingReference: ticketData.RefNumber,
        email: val.Email,
        withFare: withFare,
      };
      sendEmailSmsETicket(formData);
    }

    if (type === "Activities") {
      let formData = {
        phoneNumber: "string",
        travelType: 4,
        trigger: 1,
        bookingReference: ticketData?.TourDetails?.[0].referenceNumber,
        email: val.Email,
        withFare: withFare,
      };
      sendEmailSmsETicket(formData);
    }
    if (type === "BuildPackage") {
      let formData = {
        phoneNumber: "string",
        travelType: 5,
        trigger: 1,
        bookingReference: ticketData.bookingRefNo,
        email: val.Email,
        withFare: withFare,
        builpackageQuotation: 0,
      };
      sendEmailSmsETicket(formData);
    }
  };

  const sendSms = (val) => {
    if (limitCount.smsCount > 2) {
      message.error("Limit Exceeded");
      setSmsModalVisible(false);
      return;
    } else {
      setLimitCount((prev) => ({ ...prev, smsCount: limitCount.smsCount + 1 }));
    }
    if (type === "Bus") {
      let formData = {
        phoneNumber: val.Mobile,
        travelType: 3,
        trigger: 2,
        bookingReference: ticketData.bookingRefNo,
        email: "string",
        withFare: withFare,
      };
      sendEmailSmsETicket(formData);
    }
    if (type === "Flight") {
      let formData = {
        phoneNumber: val.Mobile,
        travelType: 1,
        trigger: 2,
        bookingReference: ticketData.id,
        email: "string",
        withFare: withFare,
      };
      sendEmailSmsETicket(formData);
    }
    if (type === "Hotel") {
      let formData = {
        phoneNumber: val.Mobile,
        travelType: 2,
        trigger: 2,
        bookingReference: ticketData.RefNumber,
        email: "string",
        withFare: withFare,
      };
      sendEmailSmsETicket(formData);
    }
  };

  const handleCancel = (cancelTicketType) => {
    onCancelTicket(cancelTicketType);
  };
  const printTicket = () => {
    window.print();
  };

  const confirmHotelBooking = () => {
    if (type === "Hotel") {
      setPgData({
        // data,
        visible: true,
      });
    }
  };

  const handleGenerateHotelVoucher = () => {
    if (type !== "Hotel") {
      return;
    }
    if (isMultiRoomPanRequiredForHotelVoucher(ticketData)) {
      if (!validateHotelVoucherPanBeforePay()) {
        return;
      }
      confirmHotelBooking();
      return;
    }
    if (isPanRequiredForHotelVoucher(ticketData, { samePanForAll: samePanForAllRooms, membership: user?.Membership })) {
      setPanModalVisible(true);
      return;
    }
    confirmHotelBooking();
  };

  const collapseHotelVoucherPayment = () => {
    setPgData({ visible: false });
    resetPayOption?.();
    setIsPaymentGatway(false);
  };

  const collapseFlightBookingPayment = () => {
    setPgData({ visible: false });
    resetPayOption?.();
    setIsPaymentGatway(false);
  };

  const normalizeCollapseKeys = (keys) =>
    Array.isArray(keys) ? keys : keys ? [keys] : [];

  const getFlightCollapseProps = (activeKey, setActiveKey) =>
    type === "Flight"
      ? {
          activeKey,
          onChange: (keys) => setActiveKey(normalizeCollapseKeys(keys)),
          animated: false,
          destroyInactivePanel: false,
        }
      : { accordion: true };

  const confirmFlightBooking = () => {

    setPgData({
      // data,
      visible: true,
    });

  };

  const blockApiReqFlightBooking = (pgType) => {
    const AirTicketRQ = {
      pnr: ticketData.pnr,
      traceId: ticketData.traceId,
      userId: ticketData['userId'],
      referenceNumber: ticketData.referenceNumber,
      pgType: pgType,
    };

    ApiClient.post("flights/airTicketConfirm", AirTicketRQ)
      .then((res) => {
        if (res.status === 200 && res.data?.payment_link) {
          window.location.href = res.data.payment_link;
        } else {
          message.error(res?.message ?? "Payment Failed", 3);
        }
      })
      .catch((error) => {
        message.error(error?.message ?? "Payment Failed", 3);
      });
  }

  const blockApiReq = (pgType) => {
    if (type === "Hotel" && pgType) {
      if (!validateHotelVoucherPanBeforePay()) {
        return;
      }
      const payableBase = getHotelTicketPayableBase(ticketData);
      const txFee =
        Number(pgType) === 1
          ? computeHotelPgTransactionFee(transactionFee, payableBase, pgType)
          : 0;

      if (Number(pgType) === 1 && !transactionFee?.methodType) {
        message.error("Please Select Payment Method Type", 3);
        return;
      }

      let data = {
        traceId: ticketData.traceId,
        referenceNo: ticketData.RefNumber,
        pgType: pgType,
        totalprice: payableBase + txFee,
        userId: user?.UserID ?? ticketData?.UserId,
        roleType: user?.Role?.RoleId ?? ticketData?.RoleType,
        ...(Number(pgType) === 1
          ? { paymentModeType: transactionFee?.methodType }
          : {}),
      };

      // Domestic + International: send ticket-verified PAN so Tripjack confirm-book gets it.
      const panReq = resolveHotelBookingPanRequired(ticketData);
      const guests = Array.isArray(ticketData?.guests) ? ticketData.guests : [];
      const hasGuestPan = guests.some((g) =>
        String(g?.pan ?? g?.Pan ?? g?.PAN ?? "").trim(),
      );
      if (
        panReq === true ||
        isInternationalHotelBooking(ticketData) ||
        hasGuestPan
      ) {
        data.guests = guests.map((g) => ({
          title: g?.title ?? g?.Title,
          firstName: g?.firstName ?? g?.FirstName,
          lastName: g?.lastName ?? g?.LastName,
          guestType: g?.guestType ?? g?.GuestType,
          guestInRoom: g?.guestInRoom ?? g?.GuestInRoom ?? g?.RoomSerialNo,
          age: g?.age ?? g?.Age,
          leadGuest: g?.leadGuest ?? g?.LeadGuest,
          pan: String(g?.pan ?? g?.Pan ?? g?.PAN ?? "").trim().toUpperCase(),
          Pan: String(g?.pan ?? g?.Pan ?? g?.PAN ?? "").trim().toUpperCase(),
        }));
      }

      ApiClient.post("hotels-v2/payandconfirmhotelblock", data)
        .then((res) => {
          if (res.status === 200) {
            const refNo = String(ticketData?.RefNumber ?? data.referenceNo ?? "").trim();
            if (refNo) {
              setHotelPendingFlow(refNo, "voucher");
            }
            window.location.href = res.data.payment_link;
          } else {
            message.error(res?.message ?? "Payment Failed", 3);
          }
        })
        .catch((error) => {
          message.error(error?.response?.data?.message ?? "Payment Failed", 3);
        });
    } else if (type === "BuildPackage" && pgType) {
      dispatchPgDetails({ type: PGTYPE, payload: pgType });
      if (pgType && agent) {
        partPayment(pgType);
      }
    }
  };

  const OnPaymentModeSelection = (e) => {
    if (e.target.value === 1) {
      setIsPaymentGatway(true);
    } else {
      setIsPaymentGatway(false);
    }
  }

  const partPayment = (pgType) => {
    let reqData = {
      userId: user?.UserID ?? 1,
      roleType: user?.Role?.RoleId ?? 4,
      currency: "AED",
      packageRefNo: ticketData.bookingRefNo,
      activitiesPackageDetails: [],
      hotelsPackageDetails: [],
      partPayment: {
        isPartPayment: IspartPayement ? true : false,
        serviceTotal: (getTransactionFee(transactionFee, ticketData.partPayment.dueAmount) + ticketData.partPayment.dueAmount),
        partPaymentAmount: ticketData.partPaymentAmount,
        dueAmount: ticketData.partPayment.dueAmount,
        serviceType: 4,
      },
      leadPassenger: {
        prefix: ticketData.leadPassenger.prefix,
        firstName: ticketData.leadPassenger.firstName,
        lastName: ticketData.leadPassenger.lastName,
        email: ticketData.leadPassenger.email,
        mobile: ticketData.leadPassenger.mobile,
        nationality: ticketData.leadPassenger.nationality,
        message: ticketData.leadPassenger.message,
        leadPassenger: 1,
        paxType: "adult",
      },
      pgType: pgType ? pgType : pgDetails.pgType,
      paymentMethod: transactionFee?.methodType,
      promoCode: promoData.Code ?? "",
      convienenceId: ConvFee.id ?? 0,
      isCouponReedem: redeemAmount.status ?? false,
    };

    ApiClient.post("buildPackage/updatePartPaymentBalance", reqData).then((response) => {
      if (response.status == 200) {
        message.success("PartPayment received successfully");
        window.location.href = response.data.payment_link;
      } else {
        message.error("PartPayment rejected with status " + response.status);
      }
    });
  };

  const getTransactionFee = (transactionFee, total) => {
    let tranxFree = 0;
    if (transactionFee?.type && (transactionFee?.type.toUpperCase() === "P" || transactionFee?.type.toUpperCase() === "F")) {
      transactionFee?.type.toUpperCase() === "P" ? tranxFree = (total / 100) * parseFloat(transactionFee.amount) : tranxFree = parseFloat(transactionFee.amount);
    }
    // setTranxFee(tranxFree);
    return tranxFree;
  }

  useEffect(() => {
    const depositTypes = {
      Flight: 1,
      Activities: 4,
      Hotel: 2,
      BuildPackage: 5,
    };
    const depositType = depositTypes[type];
    const deposits = Array.isArray(user?.Deposit) ? user.Deposit : [];
    if (depositType && deposits.includes(depositType.toString())) {
      setDeposit(true);
    } else {
      setDeposit(false);
    }
  }, [user, type]);

  const downloadSidebarHeader =
    type === "Flight"
      ? getFlightDownloadSidebarHeader(ticketData)
      : agent
        ? "Download Ticket/Invoice"
        : "Download Ticket";
  const emailSidebarHeader = type === "Flight" ? "Email" : "Email Ticket";
  const emailWithFareLabel =
    type === "Flight" ? "With Fare" : "Email With Price";
  const emailWithoutFareLabel =
    type === "Flight" ? "Without Fare" : "Email Without Price";

  return (
    <>
      {type === "Activities" && <ActivityTicketSidebar getInvoiceData={getInvoiceData} printTicket={printTicket}
        toggleEmailModal={toggleEmailModal} handleCancel={handleCancel}
        submitEmailForm={submitEmailForm} emailModalVisible={emailModalVisible}
        togglePstMrkModal={togglePstMrkModal} submitPostMarkup={submitPostMarkup}
        invoiceData={invoiceData}
        pstMrkModalVisible={pstMrkModalVisible}
        setWithFare={setWithFare}
        ticketData={ticketData}
        type={type}
        logoImage={logoImage}
        toggleVoucheredModal={toggleVoucheredModal}
        voucherData={voucherData}
        showTicketPolicyBottom={showTicketPolicyBottom}
        setShowTicketPolicyBottom={setShowTicketPolicyBottom}
        VoucheredModalVisible={VoucheredModalVisible}
        VoucheredConfirm={VoucheredConfirm}
        OnPaymentModeSelection={OnPaymentModeSelection}
        setValue={setValue}
        value={value}
        IsPaymentGatway={IsPaymentGatway}
        IsDeposit={Deposit}
      />}
      {type === "Hotel" && (
        <HotelTicketSidebar
          ticketData={ticketData}
          invoiceData={invoiceData}
          cmsFareRules={cmsFareRules}
          logoImage={logoImage}
          invoiceLogo={invoiceLogo}
          ticketMode={ticketMode}
          toggleEmailModal={toggleEmailModal}
          toggleEmailModalClose={toggleEmailModal}
          setWithFare={setWithFare}
          handleCancel={handleCancel}
          togglePstMrkModal={togglePstMrkModal}
          pstMrkModalVisible={pstMrkModalVisible}
          pstMrkForm={pstMrkForm}
          submitPostMarkup={submitPostMarkup}
          toggleRemoveMrkModal={toggleRemoveMrkModal}
          removeMrkModalVisible={removeMrkModalVisible}
          removeMrkForm={removeMrkForm}
          submitRemovePostMarkup={submitRemovePostMarkup}
          emailModalVisible={emailModalVisible}
          emailForm={emailForm}
          submitEmailForm={submitEmailForm}
          pgData={pgData}
          blockApiReq={blockApiReq}
          collapseHotelVoucherPayment={collapseHotelVoucherPayment}
          contextOnPaymentModeSelection={contextOnPaymentModeSelection}
          SeletedPayOption={SeletedPayOption}
          setValue={setValue}
          value={value}
          Deposit={Deposit}
          setPanModalVisible={setPanModalVisible}
          confirmHotelBooking={confirmHotelBooking}
          panModalVisible={panModalVisible}
          togglePanModal={togglePanModal}
          panVerified={panVerified}
          verifiedPan={verifiedPan}
          panModalError={panModalError}
          panAddLoading={panAddLoading}
          handleAddPan={handleAddPan}
          handlePanVerificationResult={handlePanVerificationResult}
          handlePanVerifyError={handlePanVerifyError}
          setPanModalError={setPanModalError}
          handleGenerateHotelVoucher={handleGenerateHotelVoucher}
          samePanForAllRooms={samePanForAllRooms}
        />
      )}
      {type !== "Activities" && type !== "Hotel" &&
        !(type === "Flight" && isFlightTicketSidebarHidden(ticketData)) &&
        <div className={`actionable-buttons${type === "Flight" ? " flight-ticket-sidebar-actions" : ""}`}>


          {type === "Flight" ? (
            <FlightTicketDownloadPanel
              ticketData={ticketData}
              fareRulesResp={fareRulesResp}
              cmsFareRules={cmsFareRules}
              logoImage={logoImage}
              invoiceData={invoiceData}
              showInvoice={
                agent && Number(invoiceData?.bookingStatus) === 3
              }
            />
          ) : (
          <div className="mb-3">
            <Collapse
              accordion
              expandIcon={() => <DownloadOutlined style={{ color: '#3d96ee' }} />}
              expandIconPosition="right"
            >
              <Panel
                header={
                  <span style={{ color: '#3d96ee' }}>
                    {downloadSidebarHeader}
                  </span>
                }
                key="1"
              >
                <div className={`trip-type-selector${type === "Flight" ? " flight-ticket-download-options" : ""}`}>
                  <div className="trip-type-selector">
                    {type === "Activities" ? (
                      <PDFDownloadLink
                        document={
                          <ActivitiesDoc
                            ticketData={ticketData}
                            withFare={true}
                            agent={agent}
                            Logo={logoImage}
                            voucherData={voucherData}
                          />
                        }
                        fileName="activitiesTicket.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button className="mb-1">
                              {agent ? "E-Ticket (With Fare)" : "With Fare"}
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                    {type === "Activities" ? (
                      <PDFDownloadLink
                        document={
                          <ActivitiesDoc
                            ticketData={ticketData}
                            withFare={false}
                            agent={agent}
                            Logo={logoImage}
                            voucherData={voucherData}
                          />
                        }
                        fileName="activitiesTicket.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button>
                              {" "}
                              {agent ? "E-Ticket (Without Fare)" : "Without Fare"}
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                    {type === "Bus" ? (
                      <PDFDownloadLink
                        document={
                          <BusDoc
                            ticketData={ticketData}
                            withFare={true}
                            Logo={logoImage}
                          />
                        }
                        fileName="busTicket.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button className="mb-1">
                              {agent ? "E-Ticket (With Fare)" : "With Fare"}
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                    {type === "Bus" ? (
                      <PDFDownloadLink
                        document={
                          <BusDoc
                            ticketData={ticketData}
                            withFare={false}
                            Logo={logoImage}
                          />
                        }
                        fileName="busTicket.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button>
                              {" "}
                              {agent ? "E-Ticket (Without Fare)" : "Without Fare"}
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                    {type === "Hotel" ? (
                      <PDFDownloadLink
                        document={
                          <HotelDoc
                            ticketData={ticketData}
                            cmsFareRules={cmsFareRules}
                            withFare={true}
                            Logo={logoImage}
                          />
                        }
                        fileName="hotelTicket.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button className="mb-1">
                              {agent ? "E-Ticket (With Fare)" : "With Fare"}
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                    {type === "Hotel" ? (
                      <PDFDownloadLink
                        document={
                          <HotelDoc
                            ticketData={ticketData}
                            cmsFareRules={cmsFareRules}
                            withFare={false}
                            Logo={logoImage}
                          />
                        }
                        fileName="hotelTicket.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button>
                              {" "}
                              {agent ? "E-Ticket (Without Fare)" : "Without Fare"}
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                    {type === "BuildPackage" && ticketData && typeof ticketData === "object" && Object.keys(ticketData).length > 0 ? (
                      <PDFDownloadLink
                        document={
                          <BuildPackageDoc
                            ticketData={ticketData}
                            withFare={true}
                            agent={agent}
                            Logo={logoImage}
                          />
                        }
                        fileName="PackageTicket.pdf"
                      >
                        {({ blob, url, loading, error }) => {
                          // Previously: if (error) { console.error("BuildPackage PDF (with fare) error:", error); }
                          // Previously: no early return on error; same return as below was used
                          if (error) {
                            // eslint-disable-next-line no-console
                            console.error("BuildPackage PDF (with fare) error:", error);
                            return (
                              <Button className="mb-1" disabled title={error?.message || "PDF generation failed"}>
                                With Fare (unavailable)
                              </Button>
                            );
                          }
                          return loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button className="mb-1">
                              {agent ? "E-Ticket (With Fare)" : "With Fare"}
                            </Button>
                          );
                        }}
                      </PDFDownloadLink>
                    ) : type === "BuildPackage" ? (
                      <Button className="mb-1" disabled title="Waiting for ticket data">
                        With Fare (unavailable)
                      </Button>
                    ) : null}
                    {type === "BuildPackage" && ticketData && typeof ticketData === "object" && Object.keys(ticketData).length > 0 ? (
                      <PDFDownloadLink
                        document={
                          <BuildPackageDoc
                            ticketData={ticketData}
                            withFare={false}
                            agent={agent}
                            Logo={logoImage}
                          />
                        }
                        fileName="PackageTicket.pdf"
                      >
                        {({ blob, url, loading, error }) => {
                          if (error) {
                            // eslint-disable-next-line no-console
                            console.error("BuildPackage PDF (without fare) error:", error);
                            return (
                              <Button disabled title={error?.message || "PDF generation failed"}>
                                {agent ? "E-Ticket (Without Fare)" : "Without Fare"} (unavailable)
                              </Button>
                            );
                          }
                          return loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button>
                              {" "}
                              {agent ? "E-Ticket (Without Fare)" : "Without Fare"}
                            </Button>
                          );
                        }}
                      </PDFDownloadLink>
                    ) : type === "BuildPackage" ? (
                      <Button disabled title="Waiting for ticket data">
                        {agent ? "E-Ticket (Without Fare)" : "Without Fare"} (unavailable)
                      </Button>
                    ) : null}

                    {[5, 7].includes(invoiceData.BookingStatus) && agent ? (
                      type === "Bus" ? (
                        <PDFDownloadLink
                          document={
                            <BusInvoiceDoc
                              invoiceData={invoiceData}
                              logo={logoImage}
                              type={"credit_note"}
                            />
                          }
                          fileName="Bus_Credit_Note.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              <Button>Loading document... </Button>
                            ) : (
                              <Button className="invoice-btn">Credit Note</Button>
                            )
                          }
                        </PDFDownloadLink>
                      ) : null
                    ) : null}

                    {invoiceData.BookingStatus === 3 && agent ? (
                      type === "Bus" ? (
                        <PDFDownloadLink
                          document={
                            <BusInvoiceDoc
                              logo={logoImage}
                              invoiceData={invoiceData}
                              type={"invoice"}
                            />
                          }
                          fileName="Bus_Invoice.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              <Button>Loading document... </Button>
                            ) : (
                              <Button className="invoice-btn">Invoice</Button>
                            )
                          }
                        </PDFDownloadLink>
                      ) : null
                    ) : null}
                    {invoiceData.bookingStatus === 3 && agent ? (
                      type === "Flight" ? (
                        <PDFDownloadLink
                          document={
                            <FlightInvoiceDoc
                              invoiceData={invoiceData}
                              logo={logoImage}
                              type={"invoice"}
                            />
                          }
                          fileName="Flight_Invoice.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              <Button>Loading document... </Button>
                            ) : (
                              <Button className="invoice-btn">Invoice</Button>
                            )
                          }
                        </PDFDownloadLink>
                      ) : null
                    ) : null}
                    {[4, 5, 6].includes(invoiceData.bookingStatus) && agent ? (
                      type === "Flight" ? (
                        <PDFDownloadLink
                          document={
                            <FlightInvoiceDoc
                              invoiceData={invoiceData}
                              logo={logoImage}
                              type={"credit_note"}
                            />
                          }
                          fileName="Flight_Credit_Note.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              <Button>Loading document... </Button>
                            ) : (
                              <Button className="invoice-btn">Credit Note</Button>
                            )
                          }
                        </PDFDownloadLink>
                      ) : null
                    ) : null}
                    {[3, 10, 11].includes(invoiceData.BookingStatus) && agent ? (
                      type === "Hotel" ? (
                        <PDFDownloadLink
                          document={
                            <HotelInvoiceDoc
                              invoiceData={invoiceData}
                              logo={logoImage}
                              type={"invoice"}
                            />
                          }
                          fileName="Hotel_Invoice.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              <Button>Loading document... </Button>
                            ) : (
                              <Button className="invoice-btn">Invoice</Button>
                            )
                          }
                        </PDFDownloadLink>
                      ) : null
                    ) : null}
                    {[6, 12].includes(invoiceData.BookingStatus) && agent ? (
                      type === "Hotel" ? (
                        <PDFDownloadLink
                          document={
                            <HotelInvoiceDoc
                              invoiceData={invoiceData}
                              logo={logoImage}
                              type={"credit_note"}
                            />
                          }
                          fileName="Hotel_Invoice.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              <Button>Loading document... </Button>
                            ) : (
                              <Button className="invoice-btn">Credit Note</Button>
                            )
                          }
                        </PDFDownloadLink>
                      ) : null
                    ) : null}

                    {invoiceData?.TourDetails?.length > 0 ? (
                      invoiceData.TourDetails[0].bookingStatus === 3 || invoiceData.TourDetails[0].bookingStatus === 7 && agent ? (
                        type === "Activities" ? (
                          <PDFDownloadLink
                            document={
                              <ActivitiesInvoiceDoc
                                invoiceData={invoiceData}
                                logo={logoImage}
                                type={"invoice"}
                              />
                            }
                            fileName="Activities_Invoice.pdf"
                          >
                            {({ blob, url, loading, error }) =>
                              loading ? (
                                <Button>Loading document... </Button>
                              ) : (
                                <Button className="invoice-btn">Invoice</Button>
                              )
                            }
                          </PDFDownloadLink>
                        ) : null
                      ) : null
                    ) : null}
                    {invoiceData?.TourDetails?.length > 0 ? (
                      invoiceData.TourDetails[0].bookingStatus === 0 && agent ? (
                        type === "Activities" ? (
                          <PDFDownloadLink
                            document={
                              <ActivitiesInvoiceDoc
                                invoiceData={invoiceData}
                                logo={logoImage}
                                type={"credit_note"}
                              />
                            }
                            fileName="Activities_Invoice.pdf"
                          >
                            {({ blob, url, loading, error }) =>
                              loading ? (
                                <Button>Loading document... </Button>
                              ) : (
                                <Button className="invoice-btn">Credit Note</Button>
                              )
                            }
                          </PDFDownloadLink>
                        ) : null
                      ) : null
                    ) : null}
                    {type === "BuildPackage" && agent ? (
                      <PDFDownloadLink
                        document={
                          <BuildPackageInvoiceDoc
                            invoiceData={invoiceData}
                            logo={logoImage}
                          />
                        }
                        fileName="Package_Invoice.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button>Loading document... </Button>
                          ) : (
                            <Button className="invoice-btn">Invoice</Button>
                          )
                        }
                      </PDFDownloadLink>
                    ) : null}
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
          )}

          {/* <div className="ticket-options">
            <p onClick={() => printTicket()}>
              <PrinterOutlined /> Print E-Ticket
            </p>
          </div> */}

          <div className={type === "Flight" ? "flight-ticket-sidebar-email" : "mb-3"}>
            <Collapse
              {...getFlightCollapseProps(flightEmailActiveKey, setFlightEmailActiveKey)}
              expandIcon={() => <MailOutlined style={{ color: '#3d96ee' }} />}
              expandIconPosition="right">
              <Panel header={
                <span style={{ color: '#3d96ee' }}>
                  {emailSidebarHeader}
                </span>
              }
                key="1">
                <div className={`trip-type-selector${type === "Flight" ? " flight-ticket-email-options" : ""}`}>
                  <div className="trip-type-selector">
                    <Button
                      block
                      className={type === "Flight" ? "flight-ticket-email-btn" : undefined}
                      style={{ marginBottom: 10 }}
                      onClick={() => {
                        toggleEmailModal();

                        setWithFare(1);
                      }}
                    >
                      {emailWithFareLabel}
                    </Button>

                    <Button
                      block
                      className={type === "Flight" ? "flight-ticket-email-btn" : undefined}
                      onClick={() => {
                        toggleEmailModal();
                        setWithFare(0);
                      }}
                    >
                      {emailWithoutFareLabel}
                    </Button>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>

          {/* {ticketData.cancellable && (
            <div className="ticket-options">
              <p onClick={() => toggleSmsModal()}>
                <MessageOutlined /> Sms E-Ticket
              </p>
            </div>
          )} */}

          {type === "Bus"
            ? ticketData.cancellable && (
              <div className="ticket-options">
                <p onClick={() => handleCancel(type)}>
                  <FileExcelOutlined /> Cancel E-Ticket
                </p>
              </div>
            )
            : null}

          {type === "Flight"
            ? shouldShowFlightSidebarActions(ticketData) &&
            ticketData.BookingStatus !== "CANCELLED" &&
            ticketData.cancellable && (
              <div className="ticket-options" style={{ backgroundColor: "#ffdbdb" }}>
                <p onClick={() => handleCancel("Flight")} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#ef6d71', marginRight: '5px', paddingLeft: '15px' }}>
                  Cancel / Reschedule Ticket <CloseCircleOutlined />
                </p>
              </div>
            )
            : null}

          {type === "Flight"
            ? shouldShowFlightSidebarActions(ticketData) &&
            ticketData.BookingStatus !== "CANCELLED" &&
            ticketData.cancellable && (
              <div className="ticket-options">
                <p onClick={() => GetReleasePnr("Flight")} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#ef6d71', marginRight: '5px', paddingLeft: '15px' }}>
                  Release PNR <FileExcelOutlined />
                </p>
              </div>
            )
            : null}

          {type === "Hotel"
            ? (ticketData.BookingStatus == 3 || ticketData.BookingStatus == 10 || ticketData.BookingStatus == 11) && // Hold Ticket will be canelation refence by Ravi 09-feb-2024
            ticketData.cancellable && (
              <div className="ticket-options" style={{ backgroundColor: "#ffdbdb" }}>
                <p onClick={() => handleCancel(type)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#ef6d71', marginRight: '5px', paddingLeft: '15px' }}>
                  Cancel Hotel <CloseCircleOutlined />
                </p>
              </div>
            )
            : null}
          {/* {type === "Activities"
        ? ticketData.cancellable && (
          <div className="ticket-options">
            <p onClick={() => handleCancel(type)}>
              <FileExcelOutlined /> Cancel E-Ticket
            </p>
          </div>
        )
        : null} */}

          {type === "BuildPackage"
            ? ticketData.cancellable && (
              <div className="ticket-options" style={{ backgroundColor: "#ffdbdb" }}>
                <p onClick={() => handleCancel(type)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#ef6d71', marginRight: '5px', paddingLeft: '15px' }}>
                  Cancel Ticket <CloseCircleOutlined />
                </p>
              </div>
            )
            : null}

          {/* Add Code By Karthik 28/April/2023 */}
          {/* {type === "Activities" && voucherData === false ? 
        <>
          <div className="ticket-options">
            <p onClick={() => toggleVoucheredModal()}>
              <DollarOutlined /> Vouchered
            </p>
          </div>
        </>
        : null} */}
          {/* Add Code By Karthik 28/April/2023 */}
          {/* {type === "Hotel" && */}
          {/* ticketData?.BookingStatus === 10 &&
          ticketData?.PurchaseType === "Block" ? ( */}
          {/* <div className="ticket-options">
            {pgData.visible ? (
              // <PaymentGateway data={pgData.data} />
              <PayGateway blockApiReq={blockApiReq} IsDeposit={Deposit} />
            ) : (
              <p onClick={() => confirmHotelBooking()} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#EE4B2B', marginRight: '5px', paddingLeft: '15px' }}>
                Generate Voucher <DollarOutlined />
              </p>
            )}
          </div> */}
          {/* ) : null} */}

          {type === "Hotel" &&
            ticketMode !== "ADMIN" &&
            ticketData?.BookingStatus === 10 &&
            ticketData?.PurchaseType === "Block" ? (
            <div className="ticket-options">
              {pgData.visible ? (
                <>
                  <PayGateway
                    blockApiReq={blockApiReq}
                    IsDeposit={Deposit}
                    OnPaymentModeSelection={contextOnPaymentModeSelection}
                    collapsiblePaymentLabel
                    onPaymentLabelClick={collapseHotelVoucherPayment}
                  />
                  {SeletedPayOption ? (
                    <div className="mb-3">
                      <PayMentSelection setValue={setValue} value={value} />
                    </div>
                  ) : null}
                </>
              ) : (
                <p
                  onClick={() => {
                    if (isPanRequiredForHotelVoucher(ticketData, { membership: user?.Membership })) {
                      setPanModalVisible(true);
                    } else {
                      confirmHotelBooking();
                    }
                  }}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: '#EE4B2B',
                    marginRight: '5px',
                    paddingLeft: '15px',
                    cursor: 'pointer',
                  }}
                >
                  Generate Voucher <DollarOutlined />
                </p>
              )}
            </div>
          ) : null}

          {agent ? (
            <>
              {/* {ticketData.cancellable ? ( 
  post markup logic visible for all conditon , discussed with  Nitin13-07-2023 */}
              {type === "BuildPackage" && IspartPayement !== true && [3, 7].includes(ticketData?.activitiesPackageDetails[0]?.optionData[0]?.BookingStatus) ? (
                <div className="ticket-options">
                  <p onClick={() => toggleVoucheredModal()} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#EE4B2B', marginRight: '5px', paddingLeft: '15px' }}>
                    Generate Voucher <DollarOutlined />
                  </p>
                </div>
              ) : null}

              {(type !== "Flight" || shouldShowFlightSidebarActions(ticketData)) && (
              <div className="ticket-options">
                <p onClick={() => togglePstMrkModal()} style={{ backgroundColor: '#f1f8ff', color: '#3d96ee' }}>
                  Add Markup <DollarOutlined />
                </p>
              </div>
              )}

              {type === "BuildPackage" && IsPaymentGatway && (
                <div className="mb-3">
                  <PayMentSelection setValue={setValue} value={value} />
                </div>
              )}

              {type === "BuildPackage" && IspartPayement == true && (
                <div className="ticket-options" >
                  {pgData.visible ? (
                    // <PaymentGateway data={pgData.data} />
                    <PayGateway blockApiReq={blockApiReq} OnPaymentModeSelection={OnPaymentModeSelection} IsDeposit={Deposit} />
                  ) : (
                    <p onClick={() => confirmFlightBooking()}>
                      <DollarOutlined /> Pay Due Amount
                    </p>
                  )}
                </div>
              )}

              {type === "BuildPackage" && IspartPayement == true && (
                <Card>
                  <div className="grandTotalDetail font-weight-bold text-danger">
                    {/* <p>Transaction Fee: INR {parseInt(getTransactionFee(transactionFee, ticketData.partPayment.dueAmount))}</p> */}
                    {/* <p>DueAmount : INR {ticketData.partPayment.dueAmount}</p> */}
                    <p>DueAmount : {activeCurrency} {currencyValue(IsPaymentGatway ? parseInt(getTransactionFee(transactionFee, ticketData.partPayment.dueAmount) + ticketData.partPayment.dueAmount) : ticketData.partPayment.dueAmount)}</p>
                  </div>
                </Card>
              )}

              {type === "Flight" &&
                shouldShowFlightSidebarActions(ticketData) &&
                (ticketData?.oneWaySegment[0]?.bookingStatus == 10 || ticketData?.returnSegment[0]?.bookingStatus == 10) &&
                ticketData?.PurchaseType === "Block" ? (
                <div className="ticket-options flight-ticket-sidebar-payment">
                  {pgData.visible ? (
                    <PayGateway
                      blockApiReq={blockApiReqFlightBooking}
                      OnPaymentModeSelection={OnPaymentModeSelection}
                      IsDeposit={Deposit}
                      collapsiblePaymentLabel
                      onPaymentLabelClick={collapseFlightBookingPayment}
                    />
                  ) : (
                    <p
                      onClick={() => confirmFlightBooking()}
                      style={{ color: "#EE4B2B", cursor: "pointer" }}
                    >
                      Confirm Booking <DollarOutlined />
                    </p>
                  )}
                </div>
              ) : null}
              {/* {type === "Flight" &&  ticketData?.BookingStatus === "HOLD" &&
        
        ticketData?.PurchaseType === "Block" ? (
          <div className="ticket-options">
            {pgData.visible ? (
              // <PaymentGateway data={pgData.data} />
              <PayGateway blockApiReq={blockApiReq} />
            ) : (
              <p onClick={() => confireFlightBooking()}>
                <DollarOutlined /> Release Ticket
              </p>
            )}
          </div>
        ) : null} */}
              {/* {type === "Hotel" &&
                ticketData?.BookingStatus === 10 &&
                ticketData?.PurchaseType === "Block" ? (
                <div className="ticket-options">
                  {pgData.visible ? (
                    // <PaymentGateway data={pgData.data} />
                    <PayGateway blockApiReq={blockApiReq} />
                  ) : (
                    <p onClick={() => confirmHotelBooking()} style={{ color: '#EE4B2B' }}>
                      <DollarOutlined /> Generate Voucher
                    </p>
                  )}
                </div>
              ) : null} */}

              <Modal
                title="Add Markup"
                width={250}
                className="promo-modal-header hotel-ticket-modal"
                closeIcon={ticketModalCloseIcon}
                visible={pstMrkModalVisible}
                onOk={togglePstMrkModal}
                onCancel={togglePstMrkModal}
                footer={[
                  <div key="markup-footer">
                    <Button key="close" onClick={togglePstMrkModal}>
                      Cancel
                    </Button>

                    <Button
                      key="add"
                      type="primary"
                      htmlType="submit"
                      onClick={pstMrkForm.submit}
                    >
                      Add
                    </Button>
                  </div>,
                ]}
              >
                <Form
                  form={pstMrkForm}
                  layout="vertical"
                  onFinish={submitPostMarkup}
                >
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        label="Amount"
                        name="amount"
                        rules={[
                          {
                            required: true,
                            message: "Required",
                          },

                          {
                            validator: (_, value) => {
                              if (Number(value) > 0) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject("Please Enter valid Amount");
                              }
                            },
                          },
                        ]}
                      >
                        <InputNumber style={{ width: "100%" }} type="number" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </>
          ) : null}

          {/* === PAN Number Modal === */}
          <Modal
            title="Enter PAN Number"
            className="promo-modal-header hotel-ticket-modal hotel-pan-modal"
            closeIcon={ticketModalCloseIcon}
            visible={panModalVisible}
            onCancel={togglePanModal}
            footer={[
              <Button key="cancel" onClick={togglePanModal}>
                Cancel
              </Button>,
              <Button
                key="add"
                type="primary"
                disabled={!panVerified || panAddLoading}
                loading={panAddLoading}
                onClick={handleAddPan}
              >
                Add
              </Button>,
            ]}
          >
            <PanVerification
              setPanVerificationNumber={handlePanVerificationResult}
              onVerifyError={handlePanVerifyError}
              onVerifyStart={() => setPanModalError("")}
              showInlineErrors
            />
            {panVerified ? (
              <p style={{ color: "green", marginTop: "10px" }}>
                ✅ PAN Verified: <strong>{verifiedPan}</strong>
              </p>
            ) : !panModalError ? (
              <p style={{ color: "gray", marginTop: "10px" }}>
                Please click <strong>Apply</strong> to verify your PAN number.
              </p>
            ) : null}
            {panModalError ? (
              <p style={{ color: "#cf1322", marginTop: "10px", fontWeight: 600 }}>
                {panModalError}
              </p>
            ) : null}
          </Modal>

          <Modal
            title="User Invoice"
            visible={userInvoiceVisible}
            onOk={() => setUserinvoiceVisible(false)}
            onCancel={() => setUserinvoiceVisible(false)}
            width={"75%"}
          >
            {/* <Invoice /> */}
          </Modal>

          <Modal
            title="Enter The Email Address"
            className="promo-modal-header hotel-ticket-modal"
            closeIcon={ticketModalCloseIcon}
            visible={emailModalVisible}
            onOk={toggleEmailModal}
            onCancel={toggleEmailModal}
            footer={[
              <div key="email-footer">
                <Button key="close" onClick={toggleEmailModal}>
                  Cancel
                </Button>

                <Button
                  key="add"
                  type="primary"
                  htmlType="submit"
                  onClick={emailForm.submit}
                >
                  Send
                </Button>
              </div>,
            ]}
          >
            <Form form={emailForm} layout="vertical" onFinish={submitEmailForm}>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Email"
                    name="Email"
                    rules={[
                      { required: true, message: "Required!" },
                      { type: "email", message: "Email is not a valid email" },
                    ]}
                  >
                    <Input placeholder="Enter The Email Address" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>

          <Modal
            title="SMS E-Ticket"
            className="promo-modal-header hotel-ticket-modal"
            closeIcon={ticketModalCloseIcon}
            visible={smsModalVisible}
            onOk={toggleSmsModal}
            onCancel={toggleSmsModal}
            footer={[
              <div key="sms-footer">
                <Button key="close" onClick={toggleSmsModal}>
                  Cancel
                </Button>

                <Button
                  key="add"
                  type="primary"
                  htmlType="submit"
                  onClick={smsForm.submit}
                >
                  Submit
                </Button>
              </div>,
            ]}
          >
            <Form form={smsForm} layout="vertical" onFinish={sendSms}>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Mobile No."
                    name="Mobile"
                    autoFocus
                    rules={[
                      {
                        required: true,
                        message: "Mobile Number Required",
                      },
                      {
                        minLength: 10,
                        maxLength: 10,
                        pattern: "^[0-9]{10}$",
                        message: "Must be 10 digits",
                      },
                    ]}
                  >
                    <Input
                      className="number-specing"
                      placeholder="Enter Mobile number"
                      autoComplete="off"
                      autoFocus
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
          {type === "BuildPackage" && (
            <Modal
              title="Vouchered"
              width={400}
              className="promo-modal-header hotel-ticket-modal"
              closeIcon={ticketModalCloseIcon}
              visible={VoucheredModalVisible}
              onOk={VoucheredConfirm}
              onCancel={toggleVoucheredModal}
              footer={[
                <div key="voucher-footer">
                  <Button key="close" onClick={() => toggleVoucheredModal()}>
                    Cancel
                  </Button>
                  <Button key="add" type="primary" onClick={VoucheredConfirm}>
                    Confirm
                  </Button>
                </div>,
              ]}
            >
              <h6 className="text-center"><strong>Note :- </strong>This Ticket will be Non Refundable and You will get this ticket in 30 Minutes</h6>
            </Modal>
          )}

        </div>}</>
  );
};
export default TicketSidebar